import { tryGetNewToken } from '../utils/Authentication';

export const interceptor = async () => {
  const { fetch: originalFetch } = window;
  window.fetch = async (...args) => {
    let [resource, config] = args;
    let response = await originalFetch(resource, config);
    if (response.status === 401) {
      await tryGetNewToken().then(async (res) => {
        if (res) {
          config.headers.Authorization = 'Bearer ' + res;
          response = await originalFetch(resource, config);
        }
      });
    }
    return response;
  };
};
